<template>
  <template v-for="f in fields" :key="f.key">
    <el-form-item v-if="!f.show || f.show(values)" :label="f.label" :required="f.required !== false">
      <div class="field-content">
        <el-select v-if="f.type === 'select'" v-model="values[f.key]" :disabled="disabled || f.readonly" clearable>
          <el-option v-for="o in f.options" :key="String(o.value)" :label="o.label" :value="o.value" />
        </el-select>
        <el-select v-else-if="f.type === 'inspector'" v-model="values[f.key]" filterable remote :remote-method="searchPeople" :loading="peopleLoading" :disabled="disabled" placeholder="输入姓名或手机号搜索">
          <el-option v-for="p in people" :key="p.id" :value="p.id" :label="`${p.nickName || '未命名'} · ${p.phone || ''} · ID ${p.id}`" />
        </el-select>
        <el-date-picker v-else-if="f.type === 'datetime'" v-model="values[f.key]" type="datetime" value-format="YYYY-MM-DD HH:mm:ss" :disabled="disabled || f.readonly" />
        <template v-else-if="f.type === 'rows'">
          <div v-for="(row, i) in values[f.key] || []" :key="i" class="component-row">
            <div class="row-title">{{ f.rowLabel || '组件' }} {{ i + 1 }} <el-button :disabled="disabled" text type="danger" @click="values[f.key].splice(i, 1)">移除</el-button></div>
            <AccountingFields :fields="f.fields" :values="row" :disabled="disabled" />
          </div>
          <el-button v-if="f.allowAdd !== false" :disabled="disabled || (values[f.key]?.length || 0) >= (f.maxRows || 100)" @click="addRow(f)">添加{{ f.rowLabel || '组件' }}</el-button>
        </template>
        <el-input v-else v-model="values[f.key]" :type="f.type === 'textarea' ? 'textarea' : 'text'" :rows="3" :maxlength="f.max || 1000" :disabled="disabled || f.readonly" :placeholder="f.required === false ? '未知/未提供时留空' : `请输入${f.label}`" />
        <div v-if="f.hint" class="hint">{{ f.hint }}</div>
      </div>
    </el-form-item>
  </template>
</template>
<script setup>
import { ref } from 'vue';
import { fetchInspectors } from '@/api/inspector';
const props = defineProps({ fields: { type: Array, required: true }, values: { type: Object, required: true }, disabled: Boolean });
const people = ref([]), peopleLoading = ref(false);
let querySeq = 0;
async function searchPeople(query) {
  const seq = ++querySeq;
  if (!query.trim()) { people.value = []; peopleLoading.value = false; return; }
  peopleLoading.value = true;
  try {
    const response = await fetchInspectors({ current: 1, pageSize: 30, ...( /^\d+$/.test(query) ? { phone: query } : { nickName: query }) });
    if (seq === querySeq) people.value = response.data?.records || [];
  } catch (_) { if (seq === querySeq) people.value = []; }
  finally { if (seq === querySeq) peopleLoading.value = false; }
}
function addRow(f) {
  if (!props.values[f.key]) props.values[f.key] = [];
  props.values[f.key].push({ ...(f.defaults || {}) });
}
</script>
<style scoped>
.field-content { width: 100%; } .field-content > .el-select, .field-content > .el-date-editor { width: 100%; }
.hint { color: #687887; font-size: 12px; line-height: 1.6; margin-top: 4px; }
.component-row { border: 1px solid #dce5ee; border-radius: 6px; padding: 14px; margin-bottom: 12px; }
.row-title { display: flex; justify-content: space-between; margin-bottom: 12px; font-weight: 600; }
</style>
